import { render, staticRenderFns } from "./account.vue?vue&type=template&id=3f131af2&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"
import style0 from "./account.vue?vue&type=style&index=0&id=3f131af2&prod&lang=less&scoped=true"
import style1 from "./account.vue?vue&type=style&index=1&id=3f131af2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f131af2",
  null
  
)

export default component.exports